/**
 * NovelMello 品牌 - Welfare 页面配置
 * 设计：头部浅渐变 + 白卡签到 7 日 + 白卡任务列表（无 Daily Reading）
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/** 主渐变（与全局 token 一致） */
const primaryGradient = brandTheme.primaryGradient || 'linear-gradient(90deg, #F0509B 0%, #9B5CF0 100%)'

/**
 * NovelMello 品牌特定主题配置
 */
export const theme = {
  // 按钮背景色（基础字段，保持与其它品牌一致）
  btnBg: brandTheme.primaryColor,
  // 按钮文本颜色
  btnText: brandTheme.textInverse,
  // 金币颜色
  coinsColor: '#FFB23E',
  // 金币数量渐变色
  coinsGradient: primaryGradient,
  // 通用渐变色（任务按钮、弹窗按钮）
  actionGradient: primaryGradient,
  // Check-in 按钮渐变色
  checkinBtnGradient: primaryGradient,

  // ↓ NovelMello 扩展（全部为 types.ts 中的可选字段）
  // 页面头部浅渐变
  headerGradient: 'linear-gradient(120deg, #FDE0EF 0%, #EDE4FD 100%)',
  // 头部金币胶囊底色
  headerPillBg: 'rgba(255, 255, 255, 0.7)',
  // 今日签到格渐变（竖向）
  todayGradient: 'linear-gradient(180deg, #F0509B 0%, #9B5CF0 100%)',
  // 未签到日格底色
  dayCellBg: '#F8F1F7',
  // 粉色浅底（Go/Ok 按钮）
  pinkSoft: '#FDEFF6',
  // 粉色浅底按钮文字色
  pinkSoftText: '#F0509B',
  // 白卡阴影
  cardShadow: '0 4px 16px rgba(124, 77, 232, 0.08)',
  // 列表分割线
  dividerColor: '#F2EAF4',
  // 金币图标色
  goldColor: '#FFB23E',
  // 任务金额文字色
  taskCoinsColor: '#E8973F',
  // 礼物（第 7 天）图标色
  giftColor: brandTheme.primaryColor,
} as const

/**
 * NovelMello 品牌特定资源配置
 */
export const resources = {
  // 头部改为纯渐变，不使用背景图（index.vue 会因空串把 homeBgUrl 置为 'none'）
  homeBg: '',
  welfareGold: '/images/novelmello/welfare-gold.png',
  // 宝箱图标（NovelMello 视图未使用，保留字段兼容类型）
  welfareBox: '/images/novelmello/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
